import { TYPES } from '../../action-types/editBillToPartyAndVatPartner';
import { IEditBillToPartyAndVatPartnerState, IEditBillToPartyAndVatPartnerAction } from './model';

export const defaultState: IEditBillToPartyAndVatPartnerState = {
    originalRowData: [],
    rowData: [],
    targetType: 'origin',
    idJob: 0,
    target: '',
    editVatMode: false,
    editVatOnlyMode: false,
};


export const reducer = (state: IEditBillToPartyAndVatPartnerState = defaultState, action: IEditBillToPartyAndVatPartnerAction) => {
    switch (action.type) {
        case TYPES.SET_ROW_DATA:
            return {
                ...state,
                originalRowData: action.payload,
                rowData: action.payload,
            };
        case TYPES.SET_TARGET_TYPE:
            return {
                ...state,
                targetType: action.payload,
            };
        case TYPES.SET_JOB_ID:
            return {
                ...state,
                idJob: action.payload,
            };
        case TYPES.SET_TARGET:
            return {
                ...state,
                target: action.payload,
            }
        case TYPES.SET_EDIT_VAT_MODE:
            return {
                ...state,
                editVatMode: action.payload,
            }
        case TYPES.SET_EDIT_VAT_ONLY_MODE:
            return {
                ...state,
                editVatOnlyMode: action.payload,
            }
        default:
            return state;
    }
};